import ServicePlanItemsTable from 'src/features/servicePlanItems/components/ServicePlanItemsTable';
import { useServicePlanTabContext } from 'src/features/servicePlans/utils/tabContext';

/** Items tab of the service plan dashboard; takes the plan's active flag from the outlet context. */
const ServicePlanItemsTab = () => {
    const { isServicePlanActive } = useServicePlanTabContext();

    return <ServicePlanItemsTable isServicePlanActive={isServicePlanActive} />;
};

export default ServicePlanItemsTab;
